











































































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import Input from "@/shared/components/ui/Input.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import moment from "moment";
import _ from "lodash";
import { formatCurrency } from "@/shared/currency";
import Button from "@/shared/components/ui/Button.vue";
import {
  ClaimSearchRequest,
  ClaimResultSet,
  FetchState,
  Claim,
  ClaimLine
} from "@/shared/types";
import { useClaimStore } from "@/employee/store/claim";


const searchInitialState: ClaimSearchRequest = {
  serviceDate: null,
  providerName: ""
};

@Component({
  components: {
    Input,
    Pagination,
    Button,
    GenericLoadingSpinner
  }
})
export default class LinkClaim extends Vue {
  claimStore = useClaimStore();

  @Prop()
  expenseId: number;

  @Prop()
  onLinkClaimsToExpense: () => void;

  formatCurrency = formatCurrency;
  searchModel: ClaimSearchRequest = { ...searchInitialState };
  comment = "";
  resultClaims = [];
  isSubmitting = false;

  beforeMount () {
    this.claimStore.initializeSearchResultState(this.expenseId);
  }

  mounted () {
    this.cloneToCurrentModel(searchInitialState);
    this.search();
  }

  get displaySearchResults (): boolean {
    return this.claimStore.searchResultsFetchState(this.expenseId) === FetchState.Loaded
      && this.claimStore.searchResults(this.expenseId).length !== 0;
  }

  get searchResultsLoading (): boolean {
    return this.claimStore.searchResultsFetchState(this.expenseId) === FetchState.Loading;
  }

  claimDateText (item: Claim): string {
    if (item.serviceDateMax === null || item.serviceDate === item.serviceDateMax) {
      return this.formattedServiceDate(item.serviceDate);
    }

    return this.formattedServiceDate(item.serviceDate) + " to </br>" + this.formattedServiceDate(item.serviceDateMax);
  }

  providerNameText (item: Claim): string {
    if (item.providersCount < 2) return item.providerName;

    return `${item.providerName} (+${item.providersCount - 1})`;
  }

  search () {
    this.claimStore.setSearchResultPageNumber({ page: 1, expenseId: this.expenseId });
    this.claimStore.searchClaims({
      pageNumber: this.claimStore.searchResultsCurrentPage(this.expenseId),
      pageSize: 5,
      serviceDate: this.searchModel.serviceDate,
      providerName: this.searchModel.providerName,
      expenseId: this.expenseId
    }).then(() => {
      this.cloneResultToCurrentModel(this.claimStore.searchResults(this.expenseId));
    });
  }
  loadPage () {
    const page = this.claimStore.searchResultsCurrentPage(this.expenseId);
    this.claimStore.searchClaims({
      pageNumber: page,
      pageSize: 5,
      serviceDate: this.searchModel.serviceDate,
      providerName: this.searchModel.providerName,
      expenseId: this.expenseId
    }).then(() => {
      this.cloneResultToCurrentModel(this.claimStore.searchResults(this.expenseId));
    });
  }

  cloneToCurrentModel (o) {
    const clonedModel = _.cloneDeep(o);
    this.searchModel = clonedModel;
  }

  cloneResultToCurrentModel (o: Claim[]) {
    o.forEach(c => c.isSelected = false);
    const clonedModel = _.cloneDeep(o);
    this.resultClaims = clonedModel;
  }

  formattedServiceDate (serviceDate: string): string {
    return moment(serviceDate).format("MMM D, YYYY");
  }

  formattedServiceDateSmall (serviceDate: string): string {
    return moment(serviceDate).calendar();
  }

  onSwitchPage (pageNumber): void {
    this.claimStore.setSearchResultPageNumber({ page: pageNumber, expenseId: this.expenseId });
    this.loadPage();
  }

  get linkClaimsDisabled (): boolean {
    if (this.isSubmitting || this.resultClaims.filter(c => c.isSelected).length > 0) {
      return false;
    }
    return true;
  }

  get linkClaimsButtonText (): string {
    if (this.resultClaims.filter(c => c.isSelected).length > 1) {
      return "Link Claims";
    }
    return "Link Claim";
  }

  toggleClaim (claimNumber: string): void {
    const claim = this.resultClaims.find(c => c.claimNumber === claimNumber);
    claim.isSelected = !claim.isSelected;
  }

  isAltRow (rowId: number): boolean {
    return rowId % 2 === 0;
  }

  link (): void {
    this.isSubmitting = true;
    const request = {
      expenseId: this.expenseId,
      claimNumbers: this.resultClaims.filter(c => c.isSelected).map(m => m.claimNumber),
      comment: this.comment
    };
    this.claimStore.linkClaimsToExpense(request).then(() => {
      this.resultClaims.forEach(c => c.isSelected = false);
      this.comment = "";
      this.search();
      this.onLinkClaimsToExpense();
    }).finally(() => {
      this.isSubmitting = false;
    });
  }
}
